import * as React from 'react'

export const CodeBlockIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.78571 8.46105H2.69667V17.979H21.3048V8.46105H19.8841V6.24025H22.0365L22.1851 6.24747C22.9226 6.3236 23.4998 6.95464 23.5 7.72078V18.7193L23.4914 18.8711C23.4212 19.5673 22.8734 20.1215 22.1851 20.1926L22.0365 20.1998H1.96492L1.81486 20.1926C1.12645 20.1217 0.578768 19.5675 0.508575 18.8711L0.5 18.7193V7.72078C0.500216 6.95454 1.07721 6.32346 1.81486 6.24747L1.96492 6.24025H3.78571V8.46105Z'
        fill='currentColor'
      />
      <path
        d='M13.1155 1.82611C13.5324 1.93794 13.7823 2.37335 13.6729 2.79916L11.4176 11.5682C11.3081 11.994 10.8812 12.2482 10.4643 12.1364C10.0478 12.0244 9.7977 11.5889 9.90695 11.1633L12.1636 2.39432C12.2731 1.96853 12.6986 1.7144 13.1155 1.82611Z'
        fill='currentColor'
      />
      <path
        d='M8.43345 4.21029C8.7457 3.90708 9.23968 3.92042 9.53679 4.23921C9.83395 4.55812 9.82184 5.0634 9.50963 5.36696L7.84891 6.98051L9.50963 8.59551C9.82185 8.89907 9.83396 9.40435 9.53679 9.72326C9.23955 10.0419 8.74558 10.0542 8.43345 9.75073L6.17818 7.55885C6.02351 7.40838 5.93665 7.19869 5.93665 6.98051C5.93676 6.76262 6.02379 6.55397 6.17818 6.40362L8.43345 4.21029Z'
        fill='currentColor'
      />
      <path
        d='M14.043 4.23921C14.3402 3.92031 14.8356 3.90676 15.1478 4.21029L17.4016 6.40362C17.5563 6.554 17.6445 6.76245 17.6446 6.98051C17.6446 7.19876 17.5564 7.40837 17.4016 7.55885L15.1478 9.75073C14.8356 10.0543 14.3402 10.0422 14.043 9.72326C13.746 9.40445 13.7583 8.89909 14.0702 8.59551L15.7309 6.98051L14.0702 5.36696C13.7581 5.06351 13.7462 4.55814 14.043 4.23921Z'
        fill='currentColor'
      />
    </svg>
  )
})

CodeBlockIcon.displayName = 'CodeBlockIcon'
